import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

const PrivacyPage = () => {
  const navigate = useNavigate();

  const handleStartTrial = () => {
    navigate('/register');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const handleWatchDemo = () => {
    // You can implement demo functionality here
    alert('Demo video will be available soon!');
  };

  return (
    <div className="main-container">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-content">
            <div className="logo-section">
              <div className="logo-icon">
                <svg className="scissors-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="6" cy="6" r="3"/>
                  <path d="m21.5 21.5-5-5"/>
                  <path d="m12 12-5-5"/>
                  <path d="m9 9 5 5"/>
                  <circle cx="6" cy="18" r="3"/>
                  <path d="m21.5 2.5-5 5"/>
                </svg>
              <span className="logo-text">ClickLooks</span>
              </div>
            </div>
            <div className="nav-buttons">
              <button className="btn-ghost" onClick={handleLogin}>Login</button>
              <button className="btn-premium btn-sm" onClick={handleStartTrial}>Start Free Trial</button>
            </div>
          </div>
        </div>
      </nav>
 

      {/* Features Grid */}
      <section className="features-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Privacy Policy</h2> 
          </div> 

<p><strong>ClickLooks</strong> is a salon management software operated by <strong><a href="https://jsnsoft.com" target="_blank">JSNSoft</a></strong>. We respect your privacy and are committed to protecting your personal and business information. This Privacy Policy explains how we collect, use, store, and safeguard information when you access or use our website and services.</p>

<p>When you register for ClickLooks, we may collect business-related information such as your name, email address, phone number, salon name, business address, and billing details. This information is necessary to create and manage your account, provide subscription access, and communicate important service updates. We may also collect technical information such as IP address, browser type, device details, and usage activity to improve the performance and security of our platform.</p>

<p>ClickLooks allows salon owners to store their customers’ information, including names, phone numbers, email addresses, appointment details, service history, and payment records. This customer data belongs solely to the salon owner. <strong>ClickLooks acts as a data processor</strong> and does not claim ownership of this information. We access such data strictly for providing technical support, resolving issues, or when legally required.</p>

<p>We use the information collected to operate and maintain our services, improve features, manage subscriptions, provide customer support, send service-related notifications, enhance security, prevent fraud, and comply with legal obligations. <strong>We do not sell, rent, or trade your personal or business information to third parties.</strong></p>

<p>For payment processing, we may use trusted third-party payment gateways. <strong>ClickLooks does not store complete credit or debit card information</strong> on its servers. All transactions are processed securely using encrypted connections (<em>SSL/HTTPS</em>).</p>

<p>We implement reasonable security measures including secure hosting infrastructure, encrypted communication, access control mechanisms, and system monitoring to protect your data. However, <em>no system can guarantee absolute security</em>, and users are encouraged to maintain strong passwords and protect their login credentials.</p>

<p>We retain your data for as long as your subscription remains active or as required to comply with legal obligations. If you terminate your account, your data may be deleted after a reasonable retention period unless required by law to be preserved.</p>

<p>ClickLooks may use third-party service providers such as hosting companies, analytics tools, email or SMS service providers, and payment processors. These providers are engaged solely to support our operations and are required to maintain appropriate confidentiality and data protection standards.</p>

<p>Our website may use cookies to maintain login sessions, enhance user experience, and analyze traffic patterns. You may disable cookies through your browser settings; however, certain features of the service may not function properly without them.</p>

<p>Depending on your jurisdiction, you may have the right to access, correct, update, or request deletion of your personal data. To exercise these rights or for any privacy-related concerns, please contact us at <strong><a href="mailto:info@clicklooks.com">info@clicklooks.com</a></strong>.</p>

<p>ClickLooks is intended for business use by salon professionals. We do not knowingly collect personal information from children under the age of 13.</p>

<p>We reserve the right to update this Privacy Policy from time to time. Any changes will be posted on this page along with an updated effective date. Continued use of the service after updates constitutes acceptance of the revised policy.</p>

<p>If you have any questions regarding this Privacy Policy, please contact us at <strong><a href="mailto:info@clicklooks.com">info@clicklooks.com</a></strong>.</p>
        </div>
      </section>
  
      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <div className="logo-icon">
                <svg className="scissors-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="6" cy="6" r="3"/>
                  <path d="m21.5 21.5-5-5"/>
                  <path d="m12 12-5-5"/>
                  <path d="m9 9 5 5"/>
                  <circle cx="6" cy="18" r="3"/>
                  <path d="m21.5 2.5-5 5"/>
                </svg>
              </div>
              <span className="logo-text">ClickLooks</span>
            </div>
            <div className="footer-links">
            <a href="/" className="footer-link">Home</a>
              <a href="/privacy" className="footer-link">Privacy</a>
              <a href="/terms" className="footer-link">Terms</a> 
              <a href="https://api.whatsapp.com/send?phone=+918555086630&text=Hello%20ClickLooks&source=&data=" className="footer-link">Contact</a>
            </div>
          </div>
          <div className="footer-bottom">
            © 2024 ClickLooks. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;
